import toastr from 'react-hot-toast'
import { useQuery } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import { CACHE_AND_STALE_TIME } from 'constants/index'
import type { FavouriteListResponse } from 'types/FavouriteList'

const getFavouriteLists = () => {
  return fetchWrapper<FavouriteListResponse>({
    url: `FavouriteLists`,
    method: 'GET',
  })
}

export function useFavouriteList() {
  const response = useQuery('favouriteLists', getFavouriteLists, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Fetch Favourite Lists: ${error.message}`)
      }
    },
    ...CACHE_AND_STALE_TIME,
  })
  const { data } = response
  const { data: favouriteList } = data || {}
  return {
    ...response,
    favouriteList,
  }
}
